<div class="circle-count" fxLayout="column" fxLayoutAlign="center stretch">
  <p class="count">{{ amount && amount !== 'null' ? amount : '-'}}</p>
  <p class="details" *ngIf="label">{{ label }}</p>
  <i *ngIf="tooltip" class="{{ icon || 'fas fa-info-circle' }}" [ngxTippy]="tooltip" [tippyProps]="tippyProps"
     tippyClassName="meeting-info-tooltip"></i>
</div>
